import React, { forwardRef } from 'react';
import {
  PALETTE, FONT_SERIF, FONT_SANS, FONT_MONO,
  HaleMark, ToxIntelMark, Backplate, Card, Eyebrow, Headline, Body, Rule, Bullet,
} from './primitives';

/* Asset 9 — Pilot Brand Recruitment Graphic
 *
 * "Seeking Pilot Brands" call-to-action. Lists the five Hale highlights
 * (regulatory readiness, claims, packaging, scientific review, dashboard
 * visibility). LinkedIn-friendly 1200×1200 square. */

const VB_W = 1200;
const VB_H = 1200;

const HIGHLIGHTS = [
  'Regulatory readiness · MoCRA · EU 1223 · Prop 65 · IFRA · PFAS',
  'Claims substantiation · defensible documentation',
  'Packaging intelligence · RSL overlays · stewardship records',
  'Independent scientific review · ToxIntel infrastructure',
  'Dashboard visibility · live status · next-action surfacing',
];

const PilotRecruitmentAsset = forwardRef(function PilotRecruitmentAsset(_props, ref) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      width="100%"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Hale pilot brand recruitment graphic"
    >
      <Backplate w={VB_W} h={VB_H} />

      {/* Top strip */}
      <HaleMark x={64} y={72} w={120} h={52} fontSize={36} />
      <text x={200} y={92} fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        POWERED BY
      </text>
      <ToxIntelMark x={200} y={120} fontSize={22} />
      <text x={VB_W - 64} y={92} textAnchor="end" fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        CALL FOR PILOT BRANDS · 2026
      </text>
      <Rule x1={0} x2={VB_W} y={170} />

      {/* Headline */}
      <Eyebrow x={64} y={246} text="Now accepting applications" />
      <Headline x={64} y={344} text="Seeking" size={104} />
      <Headline x={64} y={444} text="pilot brands." size={104} italic color={PALETTE.CORAL} />

      <Body
        x={64}
        y={510}
        size={22}
        color={PALETTE.MUTED}
        lineHeight={1.45}
        text={[
          'Beauty, wellness, grooming, fragrance, and lifestyle brands ready',
          'for independent scientific review and retailer-ready documentation.',
        ]}
      />

      {/* Highlights — full bleed list */}
      <g transform="translate(64,620)">
        <rect x={0} y={0} width={VB_W - 128} height={1} fill={PALETTE.RULE} />
        {HIGHLIGHTS.map((h, i) => (
          <g key={h} transform={`translate(0,${i * 76 + 22})`}>
            <text x={0} y={28} fill={PALETTE.CORAL} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
              {String(i + 1).padStart(2, '0')}
            </text>
            <text x={64} y={28} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={600} fontSize={26}>
              {h}
            </text>
            <rect x={0} y={56} width={VB_W - 128} height={1} fill={PALETTE.RULE} />
          </g>
        ))}
      </g>

      {/* CTA strip */}
      <g transform={`translate(64,${VB_H - 160})`}>
        <rect x={0} y={0} width={VB_W - 128} height={86} fill={PALETTE.CORAL} />
        <text x={32} y={36} fill={PALETTE.SLATE} fontFamily={FONT_MONO} fontSize={12} letterSpacing={2}>
          APPLY NOW
        </text>
        <text x={32} y={68} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={700} fontSize={28}>
          thehale.co/apply  ·  partnerships@tagc.us
        </text>
      </g>

      <text x={64} y={VB_H - 36} fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        HALE × TOXINTEL · INDEPENDENT SCIENTIFIC REVIEW BY THE AGYEKUM GROUP
      </text>
    </svg>
  );
});

export default PilotRecruitmentAsset;
